module.exports = __webpack_public_path__ + "img/modifications--without_i_drive.8736b595.png";